import { APP_DOMAIN } from "../../constants/brand";
import { useContext, useEffect, useState } from "react"
import { UserContext, UserContextPayload } from "../../Context/UserDetailContext"
import { ProfileContext, ProfileContextPayload } from "../../Context/ProfileDetailsContext"
import { useSearchParams } from "react-router-dom"
import AnnuityIncomeOutput from "../Profile/AnnuityProfiles/ProfileNewAnnuityIncome/AnnuityIncomeOutput"
import { Grid } from "@mui/material"
import globalStyles from '../../Styles/ComponentStyles/global.module.scss';
import GlobalNavbar from "../../GlobalComponent/GlobalNavbar/GlobalNavbar"
import IULOutput from "./IULOutput"
import _cloneDeep from 'lodash/cloneDeep';
import AccumulationOutput from "./AccumulationOutput"
import RothOutput from "./RothOutput"

const PROFILE_TYPE_MAP: Record<number, string> = {
    1: "IUL",
    2: "Roth Conversion",
    3: "Annuity Income",
    4: "Annuity Accumulation",
}

const ClientSharingPage = () => {

    const {
        setFlagLoader
    } = useContext(UserContext) as UserContextPayload

    const {
        getparticularUserProfileDetailForSharedProfile,
        setFinalData,
        setProfileName,
        setProfileType,
        setProfileUserDetails,
        setProfileRothConversionDetails,
        setFinalIncomeData,
        setSurplusDeficitChartData,
        setAccumulationPlanData
    } = useContext(ProfileContext) as ProfileContextPayload

    const [searchParams] = useSearchParams();
    const userProfileId = searchParams.get('profile_id');
    const userToken = searchParams.get('token');

    const [userProfileTypeId, setUserProfileTypeId] = useState<number | null>(null);


    const handleGetUserProfileDetails = async () => {
        try {
            setFlagLoader(true)
            const response = await getparticularUserProfileDetailForSharedProfile(userToken, userProfileId);
            if (response?.status && response?.inputData) {
                const input = response.inputData[0];
                const data = response?.data;
                const typeId = input?.userProfileTypeId;

                // Universal assignments (common to all types)
                setProfileName(input?.universalInput?.firstName || "");
                setProfileType(PROFILE_TYPE_MAP[typeId] ?? "")
                setUserProfileTypeId(input?.userProfileTypeId);

                if (input?.userProfileTypeId === 1) {
                    setFinalData(data?.[0]); // Final IUL plan data
                }

                if (input?.userProfileTypeId === 2) {
                    setProfileUserDetails({
                        data: _cloneDeep(data),
                        inputData: _cloneDeep(response.inputData),
                    });

                    setProfileRothConversionDetails({
                        data,
                        inputData: response.inputData,
                    });
                }

                if (input?.userProfileTypeId === 3) {
                    setFinalIncomeData(data?.[0]?.data); // Final Annuity Income plan data
                    setSurplusDeficitChartData(data?.[0]?.graphDetails)
                }

                if (input?.userProfileTypeId === 4) {
                    setFinalData(data?.[0]);
                    setAccumulationPlanData(input?.accumulationData || null);
                }
            }
            else {
                window.location.href = `https://${APP_DOMAIN}`
            }
        } catch (err) {
            console.log(`Error in fetching user profile details: ${err}`)
        } finally {
            setFlagLoader(false)
        }
    }

    useEffect(() => {
        handleGetUserProfileDetails()
    }, [])

    const renderOutputComponent = () => {
        switch (userProfileTypeId) {
            case 1:
                return <IULOutput />;
            case 2:
                return <RothOutput />;
            case 3:
                return <AnnuityIncomeOutput />;
            case 4:
                return <AccumulationOutput />;
            default:
                return <p>No valid profile type found.</p>;
        }
    };

    return (
        <>
            <Grid
                container
                direction="row"
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#FBFCFD',
                }}
            >
                <GlobalNavbar flagBorderBottom={userProfileTypeId === 3 ? true : false} />
                <Grid item xs={12}>
                    {userProfileTypeId ? renderOutputComponent() : null}
                </Grid>
            </Grid>
        </>
    )
}

export default ClientSharingPage
